import "core-js/modules/es.array.push.js";
import Sortable from 'sortablejs';
export default {
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    addTemplate: {
      type: Object,
      default: () => {}
    },
    placeholder: {
      type: String,
      default: "暂无数据"
    },
    dragSort: {
      type: Boolean,
      default: false
    },
    hideAdd: {
      type: Boolean,
      default: false
    },
    hideDelete: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      data: []
    };
  },
  mounted() {
    this.data = this.modelValue;
    if (this.dragSort) {
      this.rowDrop();
    }
  },
  watch: {
    modelValue() {
      this.data = this.modelValue;
    },
    data: {
      handler() {
        this.$emit('update:modelValue', this.data);
      },
      deep: true
    }
  },
  methods: {
    rowDrop() {
      const _this = this;
      const tbody = this.$refs.table.$el.querySelector('.el-table__body-wrapper tbody');
      Sortable.create(tbody, {
        handle: ".move",
        animation: 300,
        ghostClass: "ghost",
        onEnd({
          newIndex,
          oldIndex
        }) {
          _this.data.splice(newIndex, 0, _this.data.splice(oldIndex, 1)[0]);
          const newArray = _this.data.slice(0);
          const tmpHeight = _this.$refs.scFormTable.offsetHeight;
          _this.$refs.scFormTable.style.setProperty('height', tmpHeight + 'px');
          _this.data = [];
          _this.$nextTick(() => {
            _this.data = newArray;
            _this.$nextTick(() => {
              _this.$refs.scFormTable.style.removeProperty('height');
            });
          });
        }
      });
    },
    rowAdd() {
      const temp = JSON.parse(JSON.stringify(this.addTemplate));
      this.data.push(temp);
    },
    rowDel(row, index) {
      this.data.splice(index, 1);
    },
    //插入行
    pushRow(row) {
      const temp = row || JSON.parse(JSON.stringify(this.addTemplate));
      this.data.push(temp);
    },
    //根据index删除
    deleteRow(index) {
      this.data.splice(index, 1);
    }
  }
};